import React, { useState } from 'react'
import CustomTable from '../../../../customComponents/CustomTable'
import downloadIcon from './../../../../../Assets/icons/download.svg'
import { SPECIFICATION_TABLE_DATA,specificationKeyMapping,SPECIFICATION_TABLE_HEADERS } from '../../../../../constants/SpecificationList'
import './index.scss'
import { useNavigate } from 'react-router-dom';

const SpecificationList = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredData = SPECIFICATION_TABLE_DATA.filter(item =>
    Object.values(item).some(value =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <div>
      <div className='OnboardManagamentContainer'>
        <div className='OnboardManagamentbuttonContainer'>
          <h5>Specifications</h5>
        </div>
        
        <div>
          <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-product/specification/add-specification')}>Add Specification</button>
        </div>
      </div>
      
      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>Specifications List</h5>
            <input
              type='text'
              className='searchinput'
              placeholder='Search Specification'
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>
          <div className='downloadiconwrapper'>
            <h6 className='downloadTitle'>Download</h6>
            <img src={downloadIcon} alt='download' />
          </div>
        </div>
        
        <CustomTable data={filteredData} headers={SPECIFICATION_TABLE_HEADERS} keyMapping={specificationKeyMapping} itemsPerPage={5} />
      </div>
    </div>
  )
}

export default SpecificationList;
